/*
 * @Descripttion:
 * @version:
 * @Author: afeng510
 * @Date: 2021-08-11 20:35:52
 * @LastEditors: afeng510
 * @LastEditTime: 2021-08-26 16:54:52
 */
module.exports = {

  title: '浮云海鲜',

  /**
   * @description 接口基础访问路径（统一在此修改后端地址）
   */
  baseUrl: 'http://api.www.freshinfo.cn',
  // baseUrl: "http://127.0.0.1:7700",

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false
}
